import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NextArrow_img from 'assets/DetailImage/NextArrow.png';
import PrevArrow_img from 'assets/DetailImage/PrevArrow.png';
import default_img from 'assets/DetailImage/defaultImg.png';
import defaultProfileImage from 'assets/MemberImage/defaultProfileImage.png';
import Map from 'components/Map/Map';
import { facilityService, FacilityDetail as FacilityDetailType, FacilityReview } from 'services/facilityService';
import {
  Body,
  BackButton,
  ImageSlider,
  All,
  TextContainer,
  TitleText,
  Time,
  TimeToggle,
  TimeDropdown,
  ReviewWrap,
  StarRateWrap,
  StarText,
  ReviewButton,
  ReviewSlider,
  ReviewContainer,
  ImageContainer,
  ReviewInfo,
  ReviewDate,
  StarRateWrap2,
  ReviewDetail,
  MapInfo,
  DetailTitle,
  DetailContent,
  Map as MapContainer,
  LocationData,
  DataContainer,
  ButtonContainer,
  Button1,
  Button2,
  ArrowContainer,

} from './FacilityDetail.styles';

interface DetailDataItemProps {
  title: string;
  content: string;
}

interface ArrowProps {
  onClick?: () => void;
}

function FacilityDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [facilityData, setFacilityData] = useState<FacilityDetailType | null>(null);
  const [reviews, setReviews] = useState<FacilityReview[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [reviewsLoading, setReviewsLoading] = useState<boolean>(true);
  const [totalReviews, setTotalReviews] = useState<number>(0);
  const [averageRating, setAverageRating] = useState<number>(0);
  const [isTimeDropdownOpen, setIsTimeDropdownOpen] = useState<boolean>(false);
  // Fetch facility data
  useEffect(() => {
    const fetchFacilityData = async () => {
      if (!id) {
        setIsLoading(false);
        return;
      }

      try {
        const data = await facilityService.getFacilityDetail(Number(id));
        setFacilityData(data);
        setAverageRating(data.averageStarRating ?? 0);
        console.log('Facility data:', data);
      } catch (error) {
        console.error('Error fetching facility data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFacilityData();
  }, [id]);

  // Fetch reviews
  useEffect(() => {
    const fetchReviews = async () => {
      if (!id) {
        setReviewsLoading(false);
        return;
      }

      try {
        setReviewsLoading(true);
        const response = await facilityService.getFacilityReviews(Number(id), 0, 5, 'createdAt,DESC');
        setReviews(response.content);
        setTotalReviews(response.totalElements);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      } finally {
        setReviewsLoading(false);
      }
    };

    fetchReviews();
  }, [id]);

  const settings1 = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const settings2 = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
  };

  const STAR_IDX_ARR = ['first', 'second', 'third', 'fourth', 'last'];
  const [ratesResArr, setRatesResArr] = useState<number[]>([0, 0, 0, 0, 0]);

  const calcStarRates = (rating: number): number[] => {
    let tempStarRatesArr = [0, 0, 0, 0, 0];
    let starVerScore = (rating * 20 * 70) / 100;
    let idx = 0;
    while (starVerScore > 14) {
      tempStarRatesArr[idx] = 14;
      idx += 1;
      starVerScore -= 14;
    }
    tempStarRatesArr[idx] = starVerScore;
    return tempStarRatesArr;
  };

  useEffect(() => {
    setRatesResArr(calcStarRates(averageRating));
  }, [averageRating]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;

      if (scrollPosition >= pageHeight) {
        console.log('스크롤이 페이지 끝에 도달했습니다!');
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onClickButton1 = () => {
    navigate(`/facilities/${id}/status`);
  };

  const onClickButton2 = () => {
    navigate(`/facilities/${id}/reserve`);
  };

  const onClickReviewButton = () => {
    navigate(`/facilities/${id}/review`);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const getCurrentOperationTime = () => {
    if (!facilityData?.operationTime || facilityData.operationTime.length === 0) {
      return null;
    }

    if (facilityData.operationTime.length === 1) {
      return facilityData.operationTime[0];
    }

    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTimeInMinutes = currentHours * 60 + currentMinutes;

    // 현재 시간이 속한 운영시간 찾기
    for (const time of facilityData.operationTime) {
      const [startHours, startMinutes] = time.startTime.split(':').map(Number);
      const [endHours, endMinutes] = time.endTime.split(':').map(Number);
      const startTimeInMinutes = startHours * 60 + startMinutes;
      const endTimeInMinutes = endHours * 60 + endMinutes;

      if (currentTimeInMinutes >= startTimeInMinutes && currentTimeInMinutes < endTimeInMinutes) {
        return time;
      }
    }

    // 현재 시간이 속한 운영시간이 없으면 앞으로 시작될 운영시간 찾기
    for (const time of facilityData.operationTime) {
      const [startHours, startMinutes] = time.startTime.split(':').map(Number);
      const startTimeInMinutes = startHours * 60 + startMinutes;

      if (currentTimeInMinutes < startTimeInMinutes) {
        return time;
      }
    }

    // 모든 운영시간이 지났으면 첫 번째 운영시간 반환
    return facilityData.operationTime[0];
  };

  return (
    <Body>
      <BackButton onClick={handleGoBack}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </BackButton>
      <ImageSlider>
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <Slider {...settings1}>
            {facilityData?.images && facilityData.images.length > 0 ? (
              facilityData.images.map((image, index) => (
                <div key={index} className="slide-container">
                  <img className="img" src={image} alt={`facility${index + 1}`} />
                </div>
              ))
            ) : (
              <div className="slide-container">
                <img className="img" src={default_img} alt="이미지가 없습니다" />
              </div>
            )}
          </Slider>
        )}
      </ImageSlider>
      <All>
        <TextContainer>
          <TitleText>{facilityData?.name}</TitleText>
          <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
            {facilityData?.building.name}
          </div>
          <Time>
            {facilityData?.operationTime && facilityData.operationTime.length === 0 && (
              <span style={{ color: '#999', fontSize: '14px' }}>이용 가능 시간 정보가 없습니다.</span>
            )}
            {facilityData?.operationTime && facilityData.operationTime.length > 0 && (() => {
              const currentTime = getCurrentOperationTime();

              return (
                <>
                  {facilityData.operationTime.length === 1 ? (
                    <>
                      이용가능시간 {facilityData.operationTime[0].startTime.substring(0, 5)}~{facilityData.operationTime[0].endTime.substring(0, 5)}
                    </>
                  ) : currentTime ? (
                    <>
                      <TimeToggle onClick={() => setIsTimeDropdownOpen(!isTimeDropdownOpen)}>
                        이용가능시간 {currentTime.startTime.substring(0, 5)}~{currentTime.endTime.substring(0, 5)} {isTimeDropdownOpen ? '▲' : '▼'}
                      </TimeToggle>
                      <TimeDropdown isOpen={isTimeDropdownOpen}>
                        {facilityData.operationTime.map((time, index) => (
                          <div key={index}>
                            {time.startTime.substring(0, 5)}~{time.endTime.substring(0, 5)}
                          </div>
                        ))}
                      </TimeDropdown>
                    </>
                  ) : null}
                </>
              );
            })()}
          </Time>
        </TextContainer>

        <ReviewWrap>
          <StarRateWrap>
            {STAR_IDX_ARR.map((item, idx) => {
              return <span className='star_icon' key={`${item}_${idx}`}>
                <svg xmlns='http://www.w3.org/2000/svg' width='15' height='18' viewBox='0 0 14 13' fill='#cacaca'>
                  <clipPath id={`${item}StarClip`}>
                    <rect width={`${ratesResArr[idx]}`} height='18' />
                  </clipPath>
                  <path
                    id={`${item}Star`}
                    d='M9,2l2.163,4.279L16,6.969,12.5,10.3l.826,4.7L9,12.779,4.674,15,5.5,10.3,2,6.969l4.837-.69Z'
                    transform='translate(-2 -2)'
                  />
                  <use clipPath={`url(#${item}StarClip)`} href={`#${item}Star`} fill='#FFBE55'
                  />
                </svg>
              </span>
            })
            }
            <StarText>{averageRating.toFixed(1)}</StarText>
          </StarRateWrap>
          <ReviewButton>
            <button className="button1" onClick={onClickReviewButton}>{`리뷰 ${totalReviews}개 전체보기 >`}</button>
          </ReviewButton>
        </ReviewWrap>
      </All>
      {!reviewsLoading && reviews.length > 0 && (
        <ReviewSlider>
          <Slider {...settings2}>
            {reviews.map((item) => {
              const calcItemStarRates = (score: number): number[] => {
                let tempStarRatesArr = [0, 0, 0, 0, 0];
                let starVerScore = (score * 20 * 70) / 100;
                let idx = 0;
                while (starVerScore > 14) {
                  tempStarRatesArr[idx] = 14;
                  idx += 1;
                  starVerScore -= 14;
                }
                tempStarRatesArr[idx] = starVerScore;
                return tempStarRatesArr;
              };

              const itemStarRates = calcItemStarRates(item.startRating);

              return (
                <div key={item.id}>
                  <ReviewContainer>
                    <div className="review-slide">
                      <ImageContainer>
                        <img
                          className="img12"
                          src={item.member.profileImageUrl || defaultProfileImage}
                          alt={`review${item.id}`}
                          referrerPolicy="no-referrer"
                        />
                        <ReviewInfo>
                          <div className="nickName">{item.member.name}</div>
                          <ReviewDate>{new Date(item.createdAt).toLocaleDateString('ko-KR')}</ReviewDate>
                        </ReviewInfo>
                        <StarRateWrap2>
                          {STAR_IDX_ARR.map((starItem, idx) => {
                            return (
                              <span className='star_icon' key={`${item.id}_${idx}`}>
                                <svg xmlns='http://www.w3.org/2000/svg' width='11' height='14' viewBox='0 0 14 13' fill='#cacaca'>
                                  <clipPath id={`review_${item.id}_${starItem}StarClip`}>
                                    <rect width={`${itemStarRates[idx]}`} height='14' />
                                  </clipPath>
                                  <path
                                    id={`review_${item.id}_${starItem}Star`}
                                    d='M9,2l2.163,4.279L16,6.969,12.5,10.3l.826,4.7L9,12.779,4.674,15,5.5,10.3,2,6.969l4.837-.69Z'
                                    transform='translate(-2 -2)'
                                  />
                                  <use clipPath={`url(#review_${item.id}_${starItem}StarClip)`} href={`#review_${item.id}_${starItem}Star`} fill='#FFBE55'
                                  />
                                </svg>
                              </span>
                            );
                          })}
                        </StarRateWrap2>
                      </ImageContainer>
                      <ReviewDetail>{item.content}</ReviewDetail>
                    </div>
                  </ReviewContainer>
                </div>
              );
            })}
          </Slider>
        </ReviewSlider>
      )}
      <MapInfo>
        <DetailTitle>세부 위치</DetailTitle>
        <DetailContent>{facilityData?.location}</DetailContent>
        <MapContainer>
          {facilityData && (
            <Map
              latitude={facilityData.building.latitude}
              longitude={facilityData.building.longitude}
            />
          )}
        </MapContainer>
      </MapInfo>
      <LocationData>
        {[
          { title: '주요 목적', content: facilityData?.purpose || '' },
          { title: '이용 가능 물품', content: facilityData?.equipment || '' },
          { title: '이용 주의사항', content: facilityData?.caution || '' },
        ].map((item, index) => (
          <DetailDataItem key={index} title={item.title} content={item.content} />
        ))}
      </LocationData>

      {facilityData?.reservable && (
        <ButtonContainer>
          <Button1 onClick={() => onClickButton1()}>
            예약현황
          </Button1>
          <Button2 onClick={() => onClickButton2()}>
            예약하기
          </Button2>
        </ButtonContainer>
      )}
    </Body>
  );
}

const DetailDataItem: React.FC<DetailDataItemProps> = ({ title, content }) => {
  return (
    <DataContainer>
      <DetailTitle>{title}</DetailTitle>
      <DetailContent>{content}</DetailContent>
    </DataContainer>
  );
};

const NextArrow: React.FC<ArrowProps> = ({ onClick }) => {
  return (
    <ArrowContainer right="true" onClick={onClick}>
      <img src={NextArrow_img} alt="Next" />
    </ArrowContainer>
  );
};

const PrevArrow: React.FC<ArrowProps> = ({ onClick }) => {
  return (
    <ArrowContainer left="true" onClick={onClick}>
      <img src={PrevArrow_img} alt="Prev" />
    </ArrowContainer>
  );
};

export default FacilityDetail;
